<div #outsideModal class="modal">
  <div #modalBody class="modal-content">
    <div class="modal-header">Erreur</div>
    <div class="modal-body">
      <div *ngIf="sanitizedHtml" [innerHTML]="sanitizedHtml"></div>
    </div>
    <div class="button-wrapper">
      <frg-button (activated)="closeModal()" [backgroundColor]="'var(--darkest-primary)'">
        Fermer</frg-button>
    </div>
  </div>
</div>
<div class="modal-background"></div>